import { IMyRegistration } from "../../../model/respone/registration/IMyRegistration";
import {
    IRegistrationConfirmedPayload,
    IRegistrationFailedPayload,
} from "../../../model/respone/registration/IRegistrationResult";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eRegistrationActionTypeDefine = {
    REGISTER_START: {} as { classId: number },
    REGISTER_PENDING: {} as { classId: number },
    REGISTER_CONFIRMED: {} as IRegistrationConfirmedPayload,
    REGISTER_FAILED: {} as IRegistrationFailedPayload,
    REGISTER_ERROR: {} as { classId: number; message: string },

    /** Phase 2C: dispatch đăng ký atomic 2 lớp (parent LT + child LTH/SH). */
    REGISTER_PAIR_START: {} as { parentClassId: number; childClassId: number },

    CANCEL_START: {} as { classId: number },
    // cancelledClassIds: toàn bộ lớp đã huỷ (gồm lớp bạn cặp LT-TH). Reducer restore slot/canRegister cả 2.
    CANCEL_SUCCESS: {} as { classId: number; cancelledClassIds?: number[] },
    CANCEL_ERROR: {} as { classId: number; message: string },

    LOAD_MY_START: undefined as undefined,
    LOAD_MY_SUCCESS: [] as IMyRegistration[],
    LOAD_MY_ERROR: "" as string,

    /** SV bấm "Lưu dữ liệu đăng ký" — khoá toàn bộ đăng ký Confirmed của SV. */
    CHOT_DU_LIEU_START: undefined as undefined,
    CHOT_DU_LIEU_SUCCESS: {} as { ngayChotDuLieu: string; classIds: number[] },
    CHOT_DU_LIEU_ERROR: "" as string,

    /** Đổi đợt đăng ký: xoá myList + pending/confirmed/cancelling đợt cũ → không rò trạng thái sang đợt mới. */
    RESET: undefined as undefined,
};

export const eRegistrationActionTypeIds = generateActionTypeIds(eRegistrationActionTypeDefine, "REG");

export type IRegistrationActions = IGenericActionType<typeof eRegistrationActionTypeDefine, "REG">;
